import { SocialLoginService } from '../../ng-services/social-login.service';

export class GoogleSignInComponent {
    static $inject = ['SocialLoginService'];

    scope!: string;
    processing = false;

    onSuccess!: (payload: any) => any;
    onError!: (payload: any) => any;

    constructor(private socialLoginService: SocialLoginService) {}

    $onInit() {
        this.processing = true;

        this.socialLoginService
            .getAccessToken()
            .then((token) => {
                this.onSuccess && this.onSuccess({ token });
                this.processing = false;
            })
            .catch(() => {
                this.processing = false;
            });
    }

    async googleLogin() {
        this.processing = true;
        try {
            const token = await this.socialLoginService.signIn();
            this.onSuccess && this.onSuccess({ token });
        } catch (error) {
            console.error(error);
            this.onError && this.onError({ error });
        }

        this.processing = false;
    }
}

angular.module('tradersyard').component('tyGoogleSignIn', {
    // language=HTML
    template: `
        <button class="btn btn-primary" ng-disabled="$ctrl.processing" ng-click="$ctrl.googleLogin()">
            <i class="fa fa-circle-notch fa-spin" ng-if="$ctrl.processing"></i><i class="fab fa-google" ng-if="!$ctrl.processing"></i> Sign in with Google
        </button>
    `,
    controller: GoogleSignInComponent,
    bindings: {
        onSuccess: '&',
        onError: '&',
        scope: '@',
    },
});
